import React from 'react';
import { Collapse } from 'antd';
import PropTypes from 'prop-types';
import { useTranslation, Trans } from 'react-i18next';

// Import components
import { HomeLink } from 'components/elements';
import { Section, Title, Question, Anwser, Arrow } from './styles';

// Import helpers
import { getFAQIndex } from 'helpers/faq';
import { sendFaqEvent } from 'helpers/tracking';

// Import utilities
import { useUserAgent } from 'components/utilities';

const { REACT_APP_DEFAULT_LANGUAGE } = process.env;

function FAQSection({ items, primary, translationKey, defaultOpen }) {
	const keysRef = React.useRef([]);
	const { t } = useTranslation();
	const { isMobile } = useUserAgent();

	const onChange = (keys) => {
		const index = getFAQIndex(keys, keysRef.current);
		keysRef.current = keys;

		if (!isNaN(index)) {
			const text = t(`${translationKey}_question_${index}`, {
				lng: REACT_APP_DEFAULT_LANGUAGE
			});

			sendFaqEvent(text);
		}
	};

	return (
		<Section>
			<Title>
				<Trans t={t} i18nKey={`${translationKey}_title`} />
			</Title>

			<Collapse
				accordion={!isMobile}
				defaultActiveKey={defaultOpen}
				expandIconPosition="right"
				bordered={false}
				expandIcon={({ isActive }) => (
					<div>
						<Arrow active={`${isActive}`} />
					</div>
				)}
				onChange={onChange}
			>
				{Array.from({ length: items }, (_, index) => (
					<Question key={index} primary={primary} header={t(`${translationKey}_question_${index}`)}>
						<Anwser>
							<Trans t={t} i18nKey={`${translationKey}_answer_${index}`} components={{ homelink: <HomeLink /> }} />
						</Anwser>
					</Question>
				))}
			</Collapse>
		</Section>
	);
}

FAQSection.propTypes = {
	defaultOpen: PropTypes.number,
	primary: PropTypes.bool,
	translationKey: PropTypes.string.isRequired,
	items: PropTypes.number.isRequired
};

export default FAQSection;
